// extracted by css-extract-rspack-plugin
export default {"cls1":"WorkCard-cls1_kqG","cls2":"WorkCard-cls2_uMj WorkCard-cls1_kqG"};